import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { commApi } from './commApi';

const Switch = ({ checked, onChange, label, disabled }) => (
	<label className='flex cursor-pointer items-center gap-2 text-[14px]'>
		<input
			type='checkbox'
			className='h-4 w-4 accent-[#0f9b9d]'
			checked={!!checked}
			disabled={disabled}
			onChange={e => onChange(e.target.checked)}
		/>
		{label}
	</label>
);

// Per city: Chat on/off, may the city's admin switch it, may they read the
// audit log. The Super Admin sees every city; a city admin (when allowed)
// only the chat switch of their own city.
export const CommSettings = ({ isSuperAdmin }) => {
	const [cities, setCities] = useState(null);

	const load = () => commApi.settings().then(res => setCities(res?.cities || []));
	useEffect(() => {
		load();
	}, []);

	const update = async (cityId, patch) => {
		const res = await commApi.setSettings(cityId, patch);
		if (res?.error) {
			toast.error(typeof res.error === 'string' ? res.error : 'Κάποιο πρόβλημα προέκυψε');
		} else {
			toast.success('Αποθηκεύτηκε');
		}
		load();
	};

	if (!cities) return <div className='p-4 text-slate-400'>Φόρτωση…</div>;

	return (
		<div className='overflow-x-auto rounded-xl border border-slate-200 bg-white p-3'>
			<table className='w-full text-[14px]'>
				<thead>
					<tr className='border-b border-slate-200 text-left text-slate-500'>
						<th className='py-2 pr-3 font-normal'>Πόλη</th>
						<th className='py-2 pr-3 font-normal'>Chat</th>
						{isSuperAdmin && <th className='py-2 pr-3 font-normal'>Ο Admin αλλάζει το Chat</th>}
						{isSuperAdmin && <th className='py-2 pr-3 font-normal'>Ο Admin βλέπει το Audit</th>}
					</tr>
				</thead>
				<tbody>
					{cities.map(c => (
						<tr key={c.city_id} className='border-b border-slate-100'>
							<td className='py-2 pr-3'>{c.name || 'Η πόλη μου'}</td>
							<td className='py-2 pr-3'>
								<Switch
									checked={c.chat_enabled}
									label={c.chat_enabled ? 'ON' : 'OFF'}
									disabled={!isSuperAdmin && !c.admin_can_toggle}
									onChange={v => update(c.city_id, { chatEnabled: v })}
								/>
							</td>
							{isSuperAdmin && (
								<td className='py-2 pr-3'>
									<Switch
										checked={c.admin_can_toggle}
										label=''
										onChange={v => update(c.city_id, { adminCanToggle: v })}
									/>
								</td>
							)}
							{isSuperAdmin && (
								<td className='py-2 pr-3'>
									<Switch
										checked={c.admin_can_view_audit}
										label=''
										onChange={v => update(c.city_id, { adminCanViewAudit: v })}
									/>
								</td>
							)}
						</tr>
					))}
				</tbody>
			</table>
		</div>
	);
};
